import type { Segment } from '@fixter/i18n';
import { orderBy } from 'lodash';
import type { CmsCarMakeItem, CmsCarModelItem, CmsProductItem } from '$cms/types';
import { fetchCarMakeCollectionData } from '$server/modules/cms/fetchCarMakeCollectionData';
import { fetchCarModelCollectionData } from '$server/modules/cms/fetchCarModelCollectionData';
import { fetchProductCollectionData } from '$server/modules/cms/fetchProductCollectionData';

const MAX_POPULARITY = 10;

export const fetchPopularProducts = (segment: Segment, preview = false): Promise<CmsProductItem[]> =>
  fetchProductCollectionData({
    filter: {
      key: 'popularity',
      operator: 'lte',
      value: MAX_POPULARITY,
    },
    limit: MAX_POPULARITY,
    segment,
    preview,
  }).then((collection) => orderBy(collection, 'popularity', 'asc'));

export const fetchPopularCarMakes = (segment: Segment, preview = false): Promise<CmsCarMakeItem[]> =>
  fetchCarMakeCollectionData({
    filter: {
      key: 'popularity',
      operator: 'lte',
      value: MAX_POPULARITY,
    },
    limit: MAX_POPULARITY,
    segment,
    preview,
  }).then((collection) => orderBy(collection, 'popularity', 'asc'));

/**
 * @todo proper way to filter by make and popularity at the same time
 */
export const fetchPopularCarMakeModels = async (
  segment: Segment,
  preview = false
): Promise<CmsCarModelItem[]> => {
  const popularMakes = await fetchPopularCarMakes(segment, preview);
  return fetchCarModelCollectionData({
    filter: {
      key: 'popularity',
      operator: 'eq',
      value: 1,
    },
    limit: 1000,
    preview,
  }).then((popularModels) =>
    popularModels.filter(({ make: { id } }) => popularMakes?.some((m) => m.id === id))
  );
};

export const fetchCarMakeModels = (
  make: string,
  preview = false,
  limit = MAX_POPULARITY
): Promise<CmsCarModelItem[]> =>
  fetchCarModelCollectionData({
    filter: {
      key: 'make.id',
      operator: 'eq',
      value: make,
    },
    limit: 1000,
    preview,
  }).then((collection) => orderBy(collection, 'popularity', 'asc').slice(0, limit));
